export default "__VITE_ASSET__DkYNxOJy__"